// Heritage Crafts Skills organized by subcategories
export const HERITAGE_CRAFTS_SKILLS_CATEGORIES = [
  {
    name: 'Woodworking',
    skills: [
      'Traditional Joinery', 'Wood Carving', 'Cabinet Making',
      'Furniture Design', 'Wood Selection', 'Tool Maintenance',
      'Finishing Techniques', 'Marquetry', 'Timber Framing',
      'Wood Turning', 'Restoration', 'Pattern Making',
      'Inlay Work', 'Hand Planning', 'Traditional Tools'
    ]
  },
  {
    name: 'Metalworking',
    skills: [
      'Blacksmithing', 'Silversmithing', 'Bronze Casting',
      'Metal Forging', 'Tool Making', 'Welding',
      'Metal Finishing', 'Engraving', 'Jewelry Making',
      'Armor Making', 'Blade Smithing', 'Metal Restoration',
      'Pattern Making', 'Metal Forming', 'Traditional Tools'
    ]
  },
  {
    name: 'Textiles',
    skills: [
      'Hand Weaving', 'Embroidery', 'Tapestry Making',
      'Lace Making', 'Quilting', 'Knitting',
      'Crochet', 'Spinning', 'Dyeing',
      'Pattern Making', 'Textile Restoration', 'Fabric Selection',
      'Traditional Tools', 'Color Theory', 'Design Methods'
    ]
  },
  {
    name: 'Ceramics',
    skills: [
      'Pottery Making', 'Wheel Throwing', 'Hand Building',
      'Glazing', 'Kiln Operation', 'Clay Preparation',
      'Surface Decoration', 'Mold Making', 'Firing Techniques',
      'Tool Making', 'Restoration', 'Pattern Design',
      'Traditional Methods', 'Material Selection', 'Quality Control'
    ]
  },
  {
    name: 'Glass Making',
    skills: [
      'Glass Blowing', 'Stained Glass', 'Glass Cutting',
      'Fusing', 'Lampworking', 'Glass Painting',
      'Tool Making', 'Pattern Design', 'Color Theory',
      'Safety Methods', 'Restoration', 'Traditional Tools',
      'Material Selection', 'Quality Control', 'Design Methods'
    ]
  },
  {
    name: 'Leather Working',
    skills: [
      'Pattern Making', 'Cutting', 'Stitching',
      'Tooling', 'Dyeing', 'Finishing',
      'Tool Maintenance', 'Material Selection', 'Design Methods',
      'Traditional Tools', 'Restoration', 'Quality Control',
      'Historical Methods', 'Color Theory', 'Surface Treatment'
    ]
  },
  {
    name: 'Stone Working',
    skills: [
      'Stone Carving', 'Letter Cutting', 'Sculpture',
      'Tool Making', 'Material Selection', 'Surface Finishing',
      'Pattern Design', 'Traditional Methods', 'Restoration',
      'Safety Techniques', 'Quality Control', 'Historical Methods',
      'Design Theory', 'Tool Maintenance', 'Conservation'
    ]
  },
  {
    name: 'Paper Making',
    skills: [
      'Pulp Preparation', 'Sheet Forming', 'Paper Finishing',
      'Tool Making', 'Material Selection', 'Pattern Design',
      'Traditional Methods', 'Color Theory', 'Quality Control',
      'Conservation', 'Historical Methods', 'Design Theory',
      'Tool Maintenance', 'Surface Treatment', 'Restoration'
    ]
  },
  {
    name: 'Bookbinding',
    skills: [
      'Book Design', 'Paper Selection', 'Sewing Methods',
      'Cover Making', 'Tool Making', 'Material Selection',
      'Pattern Design', 'Traditional Methods', 'Conservation',
      'Historical Methods', 'Quality Control', 'Design Theory',
      'Tool Maintenance', 'Restoration', 'Decoration'
    ]
  },
  {
    name: 'Musical Instruments',
    skills: [
      'Instrument Design', 'Wood Selection', 'Tool Making',
      'Sound Testing', 'Material Selection', 'Traditional Methods',
      'Pattern Making', 'Finishing', 'Restoration',
      'Quality Control', 'Historical Methods', 'Design Theory',
      'Tool Maintenance', 'Conservation', 'Acoustics'
    ]
  },
  {
    name: 'Jewelry Making',
    skills: [
      'Metal Selection', 'Stone Setting', 'Design Methods',
      'Tool Making', 'Traditional Methods', 'Pattern Making',
      'Finishing', 'Quality Control', 'Historical Methods',
      'Conservation', 'Material Selection', 'Tool Maintenance',
      'Surface Treatment', 'Color Theory', 'Restoration'
    ]
  },
  {
    name: 'Printing',
    skills: [
      'Type Setting', 'Press Operation', 'Ink Selection',
      'Paper Choice', 'Tool Making', 'Traditional Methods',
      'Pattern Design', 'Color Theory', 'Quality Control',
      'Historical Methods', 'Conservation', 'Design Theory',
      'Tool Maintenance', 'Material Selection', 'Restoration'
    ]
  },
  {
    name: 'Painting',
    skills: [
      'Paint Making', 'Canvas Preparation', 'Brush Making',
      'Color Mixing', 'Traditional Methods', 'Pattern Design',
      'Surface Treatment', 'Quality Control', 'Historical Methods',
      'Conservation', 'Material Selection', 'Tool Maintenance',
      'Design Theory', 'Restoration', 'Techniques'
    ]
  },
  {
    name: 'Sculpture',
    skills: [
      'Material Selection', 'Tool Making', 'Design Methods',
      'Traditional Techniques', 'Pattern Making', 'Surface Finishing',
      'Quality Control', 'Historical Methods', 'Conservation',
      'Tool Maintenance', 'Design Theory', 'Restoration',
      'Color Theory', 'Safety Methods', 'Documentation'
    ]
  },
  {
    name: 'Conservation',
    skills: [
      'Material Analysis', 'Treatment Planning', 'Documentation',
      'Tool Selection', 'Traditional Methods', 'Pattern Recording',
      'Surface Treatment', 'Quality Control', 'Historical Research',
      'Material Selection', 'Tool Maintenance', 'Design Theory',
      'Restoration', 'Safety Methods', 'Preservation'
    ]
  },
  {
    name: 'Teaching',
    skills: [
      'Skill Assessment', 'Course Design', 'Demonstration',
      'Tool Selection', 'Traditional Methods', 'Pattern Teaching',
      'Safety Training', 'Quality Control', 'Historical Context',
      'Material Knowledge', 'Tool Maintenance', 'Design Theory',
      'Documentation', 'Student Support', 'Evaluation'
    ]
  },
  {
    name: 'Business Skills',
    skills: [
      'Market Analysis', 'Pricing Strategy', 'Customer Service',
      'Documentation', 'Traditional Methods', 'Pattern Marketing',
      'Quality Control', 'Historical Knowledge', 'Material Sourcing',
      'Tool Management', 'Design Planning', 'Sales Methods',
      'Promotion', 'Financial Planning', 'Networking'
    ]
  },
  {
    name: 'Digital Integration',
    skills: [
      'Photography', 'Documentation', 'Online Marketing',
      'Digital Design', 'Traditional Methods', 'Pattern Recording',
      'Quality Control', 'Historical Records', 'Material Database',
      'Tool Inventory', 'Design Software', 'Website Management',
      'Social Media', 'E-commerce', 'Digital Archives'
    ]
  },
  {
    name: 'Research',
    skills: [
      'Historical Research', 'Material Study', 'Technical Analysis',
      'Documentation', 'Traditional Methods', 'Pattern Recording',
      'Quality Assessment', 'Historical Context', 'Material Testing',
      'Tool Analysis', 'Design Research', 'Conservation Study',
      'Market Research', 'Innovation', 'Publication'
    ]
  },
  {
    name: 'Cultural Heritage',
    skills: [
      'Cultural Context', 'Historical Knowledge', 'Traditional Methods',
      'Pattern Preservation', 'Quality Standards', 'Heritage Management',
      'Material Culture', 'Tool History', 'Design Heritage',
      'Conservation Ethics', 'Documentation', 'Education',
      'Promotion', 'Innovation', 'Sustainability'
    ]
  }
];

// Export flattened list for backward compatibility
export const HERITAGE_CRAFTS_SKILLS = HERITAGE_CRAFTS_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
